import { openAlert, closeAlert } from "redux/slices/alertSlice";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "css/menu.module.css";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  TimePicker,
  Spin,
  ConfigProvider,
  Tag,
  Upload,
} from "antd";
import dayjs from "dayjs";
import Modal from "antd/es/modal/Modal";
import { updateMeetingTime } from "redux/slices/meetingTimeSlice";
import ResParticipantSideBox from "components/menu/resParticipantSideBox";
import ResEndpointSideBox from "components/menu/resEndpointSideBox";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ResConfirmPop from "components/menu/resConfirmPop";

/**
 * Version : 1.0
 * 작성일자 : 2023-04-12
 * 작성자 : 김희민
 * 설명 : Res
 */
export default function ResPop({
  isOpenRes,
  close,
  schedule,
  getScheduleList,
  PAGE_TYPE,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const meetingTimePayload = useSelector((state) => state.meetingTime);
  const [form] = Form.useForm();

  const [isMore, setIsMore] = useState(false);
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);

  const [inputMemberList, setInputMemberList] = useState([]);

  const [treeMemberList, setTreeMemberList] = useState([]);
  const [searchMemberList, setSearchMemberList] = useState([]);
  const [recentMemberList, setRecentMemberList] = useState([]);

  const [isOpenParticpantSideBox, setIsOpenParticpantSideBox] = useState(false);
  const [isOpenEndpointSideBox, setIsOpenEndpointSideBox] = useState(false);

  const [searchEndpointList, setSearchEndpointList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [newSchedule, setNewSchedule] = useState(schedule);
  const [fileList, setFileList] = useState([]);

  const [dateTimes, setDateTimes] = useState({
    START_DATE: null,
    END_DATE: null,
    START_TIME: null,
    END_TIME: null,
  });

  const [vcType, setVcType] = useState("");

  useEffect(() => {
    setNewSchedule({
      PROCESS_TYPE: schedule.PROCESS_TYPE || "C",
      TITLE: schedule.TITLE || "",
      CONTENTS: schedule.CONTENTS || "",
      OPEN_YN: schedule.OPEN_YN || "Y",
      RECORD_YN: schedule.RECORD_YN || "N",
      MAIL_YN: schedule.MAIL_YN || "Y",
      MEETING_PW: schedule.MEETING_PW || "",
      PARTICIPANT_LIST: schedule.PARTICIPANT_LIST || [],
      ENDPOINT_LIST: schedule.ENDPOINT_LIST || [],
      ATTACHMENT_LIST: schedule.ATTACHMENT_LIST || [],
      SCHEDULE_ID: schedule.SCHEDULE_ID || "",
      SCHEDULE_TYPE: schedule.SCHEDULE_TYPE || [],
    });
    getSystemType();

    setFileList(
      (schedule.ATTACHMENT_LIST || []).map((attachment) => ({
        uid: attachment.FILE_ID,
        name: attachment.ORI_FILE_NM,
        status: "success",
        url: attachment.FILE_URL,
      }))
    );
  }, [isOpenRes]);

  useEffect(() => {
    let startTime = schedule.START_TIME || getReserveDateTime(new Date(), 0);
    let endTime = schedule.END_TIME || getReserveDateTime(new Date(), 30);

    setDateTimes({
      START_DATE: dayjs(startTime).format("YYYY-MM-DD"),
      END_DATE: dayjs(endTime).format("YYYY-MM-DD"),
      START_TIME: dayjs(startTime).format("HH:mm"),
      END_TIME: dayjs(endTime).format("HH:mm"),
    });

    setIsPasswordEnabled(schedule.MEETING_PW !== "" ? true : false);
  }, [
    schedule.START_TIME,
    schedule.END_TIME,
    schedule.START_TIME,
    schedule.END_TIME,
    isOpenRes,
  ]);

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  const getSystemType = () => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setVcType(res.data.SYSTEM_TYPE);

          if (
            schedule.SYSTEM_TYPE !== "CD0205" &&
            schedule.SYSTEM_TYPE !== "CD0206"
          ) {
            setNewSchedule((pre) => ({
              ...pre,
              SYSTEM_TYPE: res.data.SYSTEM_TYPE,
            }));
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewSchedule((prev) => ({ ...prev, [name]: value }));
  };

  const sDateChange = (date, START_DATE) => {
    dispatch(
      updateMeetingTime({
        ...meetingTimePayload,
        TYPE: "PICKER",
        START_DATE,
      })
    );
    setNewSchedule((pre) => ({
      ...pre,
      START_TIME: START_DATE + " " + dateTimes.START_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      START_DATE,
    }));
  };
  const eDateChange = (date, END_DATE) => {
    dispatch(
      updateMeetingTime({
        ...meetingTimePayload,
        TYPE: "PICKER",
        END_DATE,
      })
    );
    setNewSchedule((pre) => ({
      ...pre,
      END_TIME: dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      END_DATE,
    }));
  };
  const sTimeChange = (time, START_TIME) => {
    if (PAGE_TYPE !== "room") {
      dispatch(
        updateMeetingTime({
          ...meetingTimePayload,
          TYPE: "PICKER",
          START_TIME: START_TIME,
        })
      );
    }
    setNewSchedule((pre) => ({
      ...pre,
      START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      START_TIME,
    }));
  };
  const eTimeChange = (time, END_TIME) => {
    if (PAGE_TYPE !== "room") {
      dispatch(
        updateMeetingTime({
          ...meetingTimePayload,
          TYPE: "PICKER",
          END_TIME,
        })
      );
    }
    setNewSchedule((pre) => ({
      ...pre,
      END_TIME: dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      END_TIME,
    }));
  };

  const pwOptionChange = (e) => {
    if (isPasswordEnabled) {
      setNewSchedule((pre) => ({
        ...pre,
        MEETING_PW: "",
      }));
    }

    setIsPasswordEnabled(e.target.checked);
  };

  const scheduleTypeChange = (e) => {
    const vcYn = e.target.value;

    setNewSchedule((pre) => ({
      ...pre,
      SCHEDULE_TYPE: vcYn === "Y" ? vcType : "CD0205",
    }));

    if (vcYn !== "Y") {
      setNewSchedule((pre) => ({
        ...pre,
        ENDPOINT_LIST: schedule.ENDPOINT_LIST,
      }));

      setSearchEndpointList(
        searchEndpointList.map((e) => ({ ...e, isChecked: false }))
      );
    }
  };

  const participantChange = (p) => {
    setNewSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return p.MEMBER_ID !== item.MEMBER_ID;
      });

      if (p.isChecked) {
        filteredList.push(p);
      }

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });
  };

  const participantDeselect = (pId) => {
    setNewSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return pId !== item.MEMBER_ID;
      });

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });

    setSearchMemberList(
      searchMemberList.map((m) =>
        m.MEMBER_ID === pId ? { ...m, isChecked: !m.isChecked } : m
      )
    );

    setRecentMemberList(
      recentMemberList.map((m) =>
        m.MEMBER_ID === pId ? { ...m, isChecked: !m.isChecked } : m
      )
    );
  };

  // default participant input
  const handleInputMemberCheck = (memberIdArr) => {
    let memberId = memberIdArr[memberIdArr.length - 1];

    if (inputMemberList.length === 1) {
      memberId = inputMemberList[0].MEMBER_ID;
    }

    if (Array.isArray(memberIdArr) && memberIdArr.length > 0) {
      const params = { MEMBER_ID: memberId };

      // const url = "/address/detail";
      // let config = {
      //   params: {
      //     MEMBER_ID: memberId,
      //   },
      // };
      axios
        // .get(url, config)
        .post("/user/detail", params)
        .then((res) => {
          if (res.status === 200) {
            let inputSearchMember = {};
            if (res.data !== "") {
              inputSearchMember = res.data;
              inputSearchMember.isChecked = !inputSearchMember.isChecked;
              participantChange(inputSearchMember);
            } else {
              const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

              if (regex.test(memberId)) {
                inputSearchMember.MEMBER_ID = memberId;
                inputSearchMember.MEMBER_NM = memberId;
                inputSearchMember.EMAIL = memberId;
                inputSearchMember.isChecked = !inputSearchMember.isChecked;
                participantChange(inputSearchMember);
              } else {
                const obj = {
                  title: "알림",
                  content: "이메일형식오류입니다.",
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                  },
                };
                dispatch(openAlert(obj));
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleInputMember = (value) => {
    if (value) {
      inputMembers(value);
    } else {
      setInputMemberList([]);
    }
  };

  const inputMembers = (value) => {
    // const params = { KET_WORDL: value };
    // // const url = "/address/searchList";
    // const url = "/user/searchList";
    // let config = {
    //   params: {
    //     KEY_WORD: value,
    //   },
    // };
    // axios
    //   .post("/user/searchList", params)
    //   // .get(url, config)
    //   .then((res) => {
    //     if (res.status === 200) {
    //       setInputMemberList(res.data);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  const endpointDeselect = (eId) => {
    setNewSchedule((pre) => {
      const filteredList = pre.ENDPOINT_LIST.filter((item) => {
        return eId !== item.ENDPOINT_ID;
      });

      return { ...pre, ENDPOINT_LIST: filteredList };
    });

    setSearchEndpointList(
      searchEndpointList.map((e) =>
        e.ENDPOINT_ID === eId ? { ...e, isChecked: !e.isChecked } : e
      )
    );
  };

  const toggleParticipantSideBox = () => {
    setIsOpenEndpointSideBox(false);
    setIsOpenParticpantSideBox(!isOpenParticpantSideBox);
  };

  const toggleEndpointBox = (e) => {
    if (newSchedule.ENDPOINT_LIST.length === 1) {
      setIsOpenParticpantSideBox(false);
      setIsOpenEndpointSideBox(true);
    } else {
      setIsOpenParticpantSideBox(false);
      setIsOpenEndpointSideBox(true);
    }
  };

  const closeParticipantSideBox = () => {
    setIsOpenParticpantSideBox(false);
  };

  const closeEndpointSideBox = () => {
    setIsOpenEndpointSideBox(false);
  };
  const [confirmInfo, setConfirmInfo] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    setNewSchedule((prev) => ({
      ...prev,
      START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
      END_TIME: dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00",
    }));

    let params = {
      PROCESS_TYPE: newSchedule.PROCESS_TYPE,
      SCHEDULE_ID: newSchedule.SCHEDULE_ID,
      SCHEDULE_TYPE: newSchedule.SCHEDULE_TYPE,
      TITLE: newSchedule.TITLE,
      CONTENTS: newSchedule.CONTENTS,
      START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
      END_TIME: dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00",
      FILE_INFO: newSchedule.FILE_INFO,
      OPEN_YN: newSchedule.OPEN_YN,
      RECORD_YN: newSchedule.RECORD_YN,
      MAIL_YN: newSchedule.MAIL_YN,
      MEETING_PW: newSchedule.MEETING_PW,
      PARTICIPANT_LIST: newSchedule.PARTICIPANT_LIST,
      ENDPOINT_LIST: newSchedule.ENDPOINT_LIST,
      ATTACHMENT_LIST: fileList,
      CHANGED: {},
    };
    setConfirmInfo(params);
    if (newSchedule.PROCESS_TYPE === "U") {
      changed.sort();
      let data = changed.join(",");
      params.CHANGED = data;
    }

    if (!confirmVal(params)) {
      return;
    }

    const formData = new FormData();
    formData.append("params", JSON.stringify(params));

    fileList.forEach((file) => {
      formData.append("files", file);
    });

    setIsOpenParticpantSideBox(false);
    setIsOpenEndpointSideBox(false);
    setLoading(true);

    if (newSchedule.PROCESS_TYPE === "C") {
      axios
        .post("/schedule/reserve", formData)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            getScheduleList();
            closePop();
            openResConfirm();
          }
        })
        .catch((error) => {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: error.response.data,
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
        });
    } else {
      axios
        .put("/schedule/reserve", formData)
        .then((res) => {
          if (res.status === 200) {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: t("MESSAGE.MODIFY_COMPLETE"),
              submitEventHandler: () => {
                getScheduleList();
                dispatch(closeAlert());
              },
            };
            dispatch(openAlert(obj));
            setLoading(false);
            closePop();
          }
        })
        .catch((error) => {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: error.response.data,
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
        });
    }
  };

  const confirmVal = (newSchedule) => {
    let isCorrect = true;

    if (
      newSchedule.TITLE === undefined ||
      newSchedule.TITLE.trim().length === 0
    ) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.TITLE_ERROR"),
        submitEventHandler: () => {
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));

      isCorrect = false;
      return isCorrect;
    }

    if (
      dayjs(newSchedule.END_TIME).diff(newSchedule.START_TIME) >
      24 * 60 * 60 * 1000
    ) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.OVER_24HOURS"),
        submitEventHandler: () => {
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));
      return;
    }

    if (isPasswordEnabled) {
      if (
        newSchedule.MEETING_PW.length < 4 ||
        newSchedule.MEETING_PW.length > 20
      ) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.MEETING_PW_ALERT"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
        return;
      }
    }

    if (systemtype === false) {
      if (newSchedule.ENDPOINT_LIST.length < 1) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: "회의실을 선택해주세요",
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
        isCorrect = false;
      }

      return isCorrect;
    }

    return isCorrect;
  };

  const closePop = () => {
    setIsMore(false);
    setIsPasswordEnabled(false);
    setIsOpenParticpantSideBox(false);
    setIsOpenEndpointSideBox(false);
    setSearchEndpointList([]);
    setNewSchedule({});
    setghostrun(true);
    setchanged([]);
    close();
  };

  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const [ghostdata, setghostdata] = useState([]);
  const [ghostrun, setghostrun] = useState(true);
  useEffect(() => {
    if (
      newSchedule.SCHEDULE_ID !== "" &&
      newSchedule.SCHEDULE_ID !== undefined &&
      newSchedule.PROCESS_TYPE === "U"
    ) {
      if (ghostrun) {
        setghostdata(newSchedule);
        setchanged([]);
        setghostrun(false);
      }
    }
  }, [ghostrun, ghostdata, newSchedule]);
  const [check, setcheck] = useState(false);
  const [changed, setchanged] = useState([]);

  const listcheck = (val1, val2, type) => {
    if (
      newSchedule.PROCESS_TYPE === "U" &&
      val1 !== undefined &&
      val2 !== undefined
    ) {
      if (type === "PARTICIPANT") {
        for (var i = 0; i < val1.length; i++) {
          let flag = false;
          for (var k = 0; k < val2.length; k++) {
            if (val1[i].MEMBER_ID === val2[k].MEMBER_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        for (var j = 0; j < val2.length; j++) {
          let flag = false;
          for (var q = 0; q < val1.length; q++) {
            if (val1[q].MEMBER_ID === val2[j].MEMBER_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        return true;
      } else if (type === "ENDPOINT") {
        for (var z = 0; z < val1.length; z++) {
          let flag = false;
          for (var x = 0; x < val2.length; x++) {
            if (val1[z].ENDPOINT_ID === val2[x].ENDPOINT_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        for (var c = 0; c < val2.length; c++) {
          let flag = false;
          for (var v = 0; v < val1.length; v++) {
            if (val1[v].ENDPOINT_ID === val2[c].ENDPOINT_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        return true;
      }
    }
  };

  useEffect(() => {
    let flags = false;
    if (ghostdata.TITLE !== newSchedule.TITLE) {
      if (!changed.includes("회의 명")) {
        setchanged(changed.concat("회의 명"));
      }
      flags = true;
    } else {
      if (changed.includes("회의 명")) {
        setchanged(changed.filter((data) => data !== "회의 명"));
      }
    }
    if (ghostdata.CONTENTS !== newSchedule.CONTENTS) {
      flags = true;
      if (!changed.includes("회의 내용")) {
        setchanged(changed.concat("회의 내용"));
      }
    } else {
      if (changed.includes("회의 내용")) {
        setchanged(changed.filter((data) => data !== "회의 내용"));
      }
    }
    if (
      ghostdata.START_TIME !==
      dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00"
    ) {
      flags = true;
      if (!changed.includes("시작 시간")) {
        setchanged(changed.concat("시작 시간"));
      }
    } else {
      if (changed.includes("시작 시간")) {
        setchanged(changed.filter((data) => data !== "시작 시간"));
      }
    }
    if (
      ghostdata.END_TIME !==
      dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00"
    ) {
      flags = true;
      if (!changed.includes("종료 시간")) {
        setchanged(changed.concat("종료 시간"));
      }
    } else {
      if (changed.includes("종료 시간")) {
        setchanged(changed.filter((data) => data !== "종료 시간"));
      }
    }

    if (
      ghostdata.PARTICIPANT_LIST !== undefined &&
      newSchedule.PARTICIPANT_LIST !== undefined
    ) {
      if (
        !listcheck(
          ghostdata.PARTICIPANT_LIST,
          newSchedule.PARTICIPANT_LIST,
          "PARTICIPANT"
        )
      ) {
        flags = true;
        if (!changed.includes("참석자")) {
          setchanged(changed.concat("참석자"));
        }
      } else {
        if (changed.includes("참석자")) {
          setchanged(changed.filter((data) => data !== "참석자"));
        }
      }
    }

    if (
      ghostdata.ENDPOINT_LIST !== undefined &&
      newSchedule.ENDPOINT_LIST !== undefined
    ) {
      if (
        !listcheck(
          ghostdata.ENDPOINT_LIST,
          newSchedule.ENDPOINT_LIST,
          "ENDPOINT"
        )
      ) {
        flags = true;
        if (!changed.includes("회의실")) {
          setchanged(changed.concat("회의실"));
        }
      } else {
        if (changed.includes("ENDPOINT")) {
          setchanged(changed.filter((data) => data !== "회의실"));
        }
      }
    }
    let optionboolean = false;
    if (ghostdata.MAIL_YN !== newSchedule.MAIL_YN) {
      flags = true;
      optionboolean = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.MEETING_PW !== newSchedule.MEETING_PW) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.RECORD_YN !== newSchedule.RECORD_YN) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.OPEN_YN !== newSchedule.OPEN_YN) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (flags) {
      setcheck(true);
    } else {
      setcheck(false);
      setchanged([]);
    }
  }, [newSchedule, dateTimes]);

  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 5,
          backgroundColor: "#ededed",
          borderColor: "#ededed",
          borderRadius: "15.5px",
          padding: "6px 13px 6px 11.5px",
          color: "#121212",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {label}
      </Tag>
    );
  };

  const props = {
    onRemove: (file) => {
      setFileList((prev) => {
        const index = prev.indexOf(file);
        const newFileList = prev.slice();
        newFileList.splice(index, 1);
        return newFileList;
      });
    },
    beforeUpload: (file) => {
      setFileList((prev) => [...prev, file]);
      return false;
    },
    fileList,
  };

  const [isOpenResConfirm, setIsOpenResConfirm] = useState(false);
  const openResConfirm = () => {
    setIsOpenResConfirm(true);
  };
  const closeResConfirm = () => {
    setIsOpenResConfirm(false);
  };

  const systemtype = useSelector((state) => state.system.isOnline);

  return (
    <>
      <ResConfirmPop
        isOpenResConfirm={isOpenResConfirm}
        close={closeResConfirm}
        schedule={confirmInfo}
      />
      <ConfigProvider
        theme={{
          components: {
            Select: {
              colorTextDescription: "#fff",
            },
            Input: {
              borderRadius: "5px",
            },
            DatePicker: {
              colorInfoText: "#fff",
            },
            Radio: {
              colorBorder: "#fff",
            },
            Upload: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              colorPrimaryActive: "#1cb691",
            },
          },
        }}
      >
        <Modal
          className={style.res_popup}
          open={isOpenRes}
          closable={false}
          onCancel={closePop}
          maskClosable={false}
          footer={null}
          wrapClassName={style.res_popup_modal_wrap}
        >
          <Form form={form} onFinish={handleSubmit}>
            <Spin spinning={loading} style={{ maxHeight: "none" }}>
              <div className={style.res_popup_wrap}>
                <div className={style.res_popup_container}>
                  <div className={style.res_popup_content_contaier}>
                    <div>
                      <article className={style.res_popup_header}>
                        <p className={style.title}>
                          {newSchedule.PROCESS_TYPE === "U"
                            ? t("LABEL.TITLE.SCHEDULE_MODIFY")
                            : t("LABEL.TITLE.SCHEDULE_RESERVATION")}
                        </p>
                        <img
                          className={style.res_popup_sideBox_closeBtn}
                          src={
                            process.env.REACT_APP_CLIENT_URL +
                            "img/menu/close.png"
                          }
                          alt="close"
                          onClick={() => closePop()}
                        />
                      </article>
                      <div className={style.res_popup_body}>
                        <Form.Item style={{ marginBottom: "14px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.MEETING_TITLE")}
                          </div>
                          <Input
                            name="TITLE"
                            size="large"
                            value={newSchedule.TITLE ?? ""}
                            onChange={handleChange}
                            placeholder={t("PLACEHOLDER.INPUT.WRITE_TITLE")}
                            className={style.res_popup_input_value}
                          />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: "14px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.MEETING_DATE_TIME")}
                          </div>
                          <div style={{ marginBottom: "8px" }}>
                            <DatePicker
                              value={
                                dateTimes.START_DATE === ""
                                  ? null
                                  : dayjs(
                                      dateTimes.START_DATE +
                                        " " +
                                        dateTimes.START_TIME +
                                        ":00"
                                    )
                              }
                              name="START_DATE"
                              size="large"
                              className={style.res_popup_date}
                              placeholder={t(
                                "PLACEHOLDER.INPUT.RESERVE_START_DATE"
                              )}
                              onChange={sDateChange}
                            />
                            <TimePicker
                              value={
                                dateTimes.START_DATE === ""
                                  ? null
                                  : dayjs(
                                      dateTimes.START_DATE +
                                        " " +
                                        dateTimes.START_TIME +
                                        ":00"
                                    )
                              }
                              name="START_TIME"
                              size="large"
                              className={style.res_popup_time}
                              format={"HH:mm"}
                              minuteStep={10}
                              placeholder={t(
                                "PLACEHOLDER.INPUT.RESERVE_START_TIME"
                              )}
                              onChange={sTimeChange}
                            />
                          </div>
                          <div>
                            <DatePicker
                              value={
                                dateTimes.END_DATE === ""
                                  ? null
                                  : dayjs(
                                      dateTimes.END_DATE +
                                        " " +
                                        dateTimes.END_TIME +
                                        ":00"
                                    )
                              }
                              name="END_DATE"
                              size="large"
                              className={style.res_popup_date}
                              placeholder={t(
                                "PLACEHOLDER.INPUT.RESERVE_END_DATE"
                              )}
                              onChange={eDateChange}
                            />
                            <TimePicker
                              value={
                                dateTimes.END_DATE === ""
                                  ? null
                                  : dayjs(
                                      dateTimes.END_DATE +
                                        " " +
                                        dateTimes.END_TIME +
                                        ":00"
                                    )
                              }
                              name="END_TIME"
                              size="large"
                              className={style.res_popup_time}
                              format={"HH:mm"}
                              minuteStep={10}
                              placeholder={t(
                                "PLACEHOLDER.INPUT.RESERVE_END_TIME"
                              )}
                              onChange={eTimeChange}
                            />
                          </div>
                        </Form.Item>
                        {systemtype === false ? (
                          ""
                        ) : (
                          <Form.Item style={{ marginBottom: "14px" }}>
                            <div className={style.res_popup_input_label}>
                              {t("LABEL.TYPE")}
                            </div>
                            <div className={style.res_popup_input_scheduleType}>
                              <div
                                className={
                                  style.res_popup_input_scheduleType_label
                                }
                              >
                                {t("LABEL.VIDEO_MEETING_YN")}
                              </div>
                              <Radio.Group
                                name="VC_YN"
                                optionType="button"
                                value={
                                  systemtype === false
                                    ? "N"
                                    : newSchedule.SCHEDULE_TYPE !== "CD0205"
                                    ? "Y"
                                    : "N"
                                }
                                className={style.res_popup_radio_group}
                                onChange={scheduleTypeChange}
                                disabled={
                                  newSchedule.PROCESS_TYPE === "U"
                                    ? true
                                    : false
                                }
                              >
                                <Radio
                                  value="Y"
                                  className={style.res_popup_radio_scheduleType}
                                >
                                  {t("common.button.yes")}
                                </Radio>
                                <Radio
                                  value="N"
                                  className={style.res_popup_radio_scheduleType}
                                >
                                  {t("common.button.no")}
                                </Radio>
                              </Radio.Group>
                            </div>
                          </Form.Item>
                        )}

                        <Form.Item style={{ marginBottom: "14px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.MEETING_PLACE")}
                          </div>
                          <Select
                            mode="tags"
                            name="ENDPOINT_LIST"
                            size="large"
                            placeholder={t(
                              "PLACEHOLDER.INPUT.SELECT_MEETING_ROOM"
                            )}
                            value={(newSchedule.ENDPOINT_LIST || []).map(
                              (endpoint) => ({
                                value: endpoint.ENDPOINT_ID,
                                label: endpoint.ENDPOINT_NM,
                              })
                            )}
                            notFoundContent={null}
                            onDeselect={endpointDeselect}
                            onFocus={toggleEndpointBox}
                            filterOption={filterOption}
                            tagRender={tagRender}
                            inputValue=""
                          ></Select>
                        </Form.Item>
                        <Form.Item style={{ marginBottom: "14px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.MEETING_PTCP")}
                          </div>
                          <div className={style.res_popup_input_participant}>
                            <Select
                              mode="tags"
                              name="PARTICIPANT_LIST"
                              size="large"
                              className={
                                style.res_popup_input_participant_value
                              }
                              placeholder={t("PLACEHOLDER.INPUT.PTCP_EMAIL")}
                              value={(newSchedule.PARTICIPANT_LIST || []).map(
                                (participant) => ({
                                  value: participant.MEMBER_ID,
                                  label: participant.MEMBER_NM,
                                })
                              )}
                              notFoundContent={null}
                              onDeselect={participantDeselect}
                              onSearch={handleInputMember}
                              onChange={handleInputMemberCheck}
                              tokenSeparators={[","]}
                              options={(inputMemberList || []).map(
                                (member) => ({
                                  value: member.MEMBER_ID,
                                  label: member.MEMBER_NM,
                                })
                              )}
                              showSearch
                              filterOption={filterOption}
                              tagRender={tagRender}
                            ></Select>
                            <Button
                              className={style.res_popup_add_btn}
                              onClick={toggleParticipantSideBox}
                            >
                              {t("BTN.ADD")}
                            </Button>
                          </div>
                        </Form.Item>
                        <Button
                          onClick={(e) => {
                            setIsMore(!isMore);
                          }}
                          className={`${style.res_popup_btn_more} ${
                            isMore ? style.open : ""
                          }`}
                        >
                          {t("BTN.MORE_OPTIONS")}
                        </Button>
                        <div
                          className={`${style.res_popup_more} ${
                            isMore ? style.open : ""
                          }`}
                        >
                          <Row gutter={16}>
                            {systemtype === false ? (
                              ""
                            ) : (
                              <Col span={12}>
                                <Form.Item style={{ marginBottom: "14px" }}>
                                  <div className={style.res_popup_input_label}>
                                    {t("LABEL.VIDEO_RECORD_YN")}
                                    <Checkbox
                                      name="RECORD_YN"
                                      checked={newSchedule.RECORD_YN === "Y"}
                                      value="Y"
                                      className={style.res_popup_checkbox}
                                      onChange={handleChange}
                                      disabled={
                                        newSchedule.SCHEDULE_TYPE === "CD0205"
                                          ? true
                                          : false
                                      }
                                    >
                                      {t("common.button.yes")}
                                    </Checkbox>
                                    <Checkbox
                                      name="RECORD_YN"
                                      checked={
                                        newSchedule.RECORD_YN === "N" ||
                                        newSchedule.RECORD_YN === undefined
                                      }
                                      value="N"
                                      onChange={handleChange}
                                      className={style.res_popup_checkbox}
                                      disabled={
                                        newSchedule.SCHEDULE_TYPE === "CD0205"
                                          ? true
                                          : false
                                      }
                                    >
                                      {t("common.button.no")}
                                    </Checkbox>
                                  </div>
                                </Form.Item>
                              </Col>
                            )}

                            <Col span={12}>
                              <Form.Item style={{ marginBottom: "14px" }}>
                                <div className={style.res_popup_input_label}>
                                  {t("LABEL.SEND_MAIL_YN")}
                                  <Checkbox
                                    name="MAIL_YN"
                                    checked={
                                      newSchedule.MAIL_YN === "Y" ||
                                      newSchedule.MAIL_YN === undefined
                                    }
                                    value="Y"
                                    className={style.res_popup_checkbox}
                                    onChange={handleChange}
                                  >
                                    {t("common.button.yes")}
                                  </Checkbox>
                                  <Checkbox
                                    name="MAIL_YN"
                                    checked={newSchedule.MAIL_YN === "N"}
                                    value="N"
                                    onChange={handleChange}
                                    className={style.res_popup_checkbox}
                                  >
                                    {t("common.button.no")}
                                  </Checkbox>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                          {systemtype === false ? (
                            ""
                          ) : (
                            <Form.Item style={{ marginBottom: "14px" }}>
                              <div className={style.res_popup_input_label}>
                                {t("LABEL.SET_PW_YN")}
                                <Checkbox
                                  name="PW_OPTION"
                                  checked={isPasswordEnabled}
                                  onChange={pwOptionChange}
                                  className={style.res_popup_checkbox}
                                  disabled={
                                    newSchedule.SCHEDULE_TYPE === "CD0205"
                                      ? true
                                      : false
                                  }
                                ></Checkbox>
                                <Input.Password
                                  name="MEETING_PW"
                                  onChange={handleChange}
                                  value={newSchedule.MEETING_PW ?? ""}
                                  style={{
                                    width: "calc(100% - 140px)",
                                    marginLeft: "20px",
                                  }}
                                  disabled={
                                    !(
                                      isPasswordEnabled &&
                                      newSchedule.SCHEDULE_TYPE !== "CD0205"
                                    )
                                  }
                                />
                              </div>
                            </Form.Item>
                          )}

                          {systemtype === false ? (
                            ""
                          ) : (
                            <Form.Item style={{ marginBottom: "14px" }}>
                              <div className={style.res_popup_input_label}>
                                {t("LABEL.MEETING_LIST")}
                                <Radio.Group
                                  name="OPEN_YN"
                                  onChange={handleChange}
                                  value={newSchedule.OPEN_YN}
                                  optionType="button"
                                  buttonStyle="solid"
                                >
                                  <Radio
                                    value="Y"
                                    className={style.res_popup_radio}
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                  >
                                    {t("BTN.PUBLIC")}
                                  </Radio>
                                  <Radio
                                    value="N"
                                    className={style.res_popup_radio}
                                  >
                                    {t("BTN.PRIVATE")}
                                  </Radio>
                                </Radio.Group>
                                <span className={style.res_popup_openYn_label}>
                                  {t("MESSAGE.MEETING_LIST_NOTICE")}
                                </span>
                              </div>
                            </Form.Item>
                          )}

                          <Form.Item style={{ marginBottom: "14px" }}>
                            <div className={style.res_popup_input_label}>
                              {t("LABEL.MEMO")}
                            </div>
                            <Input.TextArea
                              rows={2}
                              name="CONTENTS"
                              value={newSchedule.CONTENTS ?? ""}
                              placeholder={t("PLACEHOLDER.INPUT.WRITE_CONTENT")}
                              onChange={handleChange}
                              className={style.res_popup_input_value}
                            />
                          </Form.Item>
                          <Form.Item style={{ marginBottom: "20px" }}>
                            <div className={style.res_popup_input_label}>
                              {t("LABEL.ATTACHMENT")}
                              <Upload {...props} fileList={fileList}>
                                <Button className={style.res_popup_upload_btn}>
                                  {t("BTN.ADD")}
                                  <UploadOutlined />
                                </Button>
                              </Upload>
                            </div>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={style.res_popup_btn_container}>
                    <Button
                      type="primary"
                      onClick={() => closePop()}
                      className={style.res_popup_close_btn}
                    >
                      {t("BTN.CANCEL")}
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSubmit}
                      className={style.res_popup_save_btn}
                    >
                      {newSchedule.PROCESS_TYPE === "U"
                        ? t("BTN.MODIFY")
                        : t("BTN.RESERVE")}
                    </Button>
                  </div>
                </div>
              </div>
            </Spin>
            <ResParticipantSideBox
              isOpenParticpantSideBox={isOpenParticpantSideBox}
              closeParticipantSideBox={closeParticipantSideBox}
              participantChange={participantChange}
              treeMemberList={treeMemberList}
              searchMemberList={searchMemberList}
              recentMemberList={recentMemberList}
              setTreeMemberList={setTreeMemberList}
              setSearchMemberList={setSearchMemberList}
              setRecentMemberList={setRecentMemberList}
              schedule={newSchedule}
            />
            <ResEndpointSideBox
              isOpenEndpointSideBox={isOpenEndpointSideBox}
              closeEndpointSideBox={closeEndpointSideBox}
              searchEndpointList={searchEndpointList}
              setSearchEndpointList={setSearchEndpointList}
              schedule={newSchedule}
              setSchedule={setNewSchedule}
              dateTimes={dateTimes}
            />
          </Form>
        </Modal>
      </ConfigProvider>
    </>
  );
}
